export const DisableFeatureFlags = {
  /** Dynamic Code Injection */
  DCI: 'DCI',
  /** Google Tag Manager */
  GTM: 'GTM',
  /** MEP (Interaction studio) */
  MEP: 'MEP',
  /** INTERSTITIAL (Newsletter interstitial) */
  INTERSTITIAL: 'INTERSTITIAL',
  /** CAPTCHA (Captcha) */
  CAPTCHA: 'CAPTCHA',
  /** TPS (Third Party Script [pear commerce, e.g.]) */
  TPS: 'TPS',
  /** OT (One Trust) */
  OT: 'OT',
  /** BV (Bazaar Voice) */
  BV: 'BV',
  /** PEAR_RECIPE (Pear recipe) */
  PEAR: 'PEAR',
  /** Ad Choices (AdChoices) */
  ADCHOICES: 'ADCHOICES',
} as const;

export type DisableFeatureFlag = keyof typeof DisableFeatureFlags;
